import React from 'react';
import { SuccessModal as SharedSuccessModal } from '@jagad/ui';
import type { SuccessModalProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type TMASuccessModalProps = Omit<SuccessModalProps, 'defaultMessage'> & {
  defaultMessage?: string;
};

const SuccessModal: React.FC<TMASuccessModalProps> = ({ defaultMessage, ...props }) => {
  const { t } = useTranslation();
  const resolvedDefaultMessage = defaultMessage ?? t('components.successModal.defaultMessage');

  return <SharedSuccessModal {...props} defaultMessage={resolvedDefaultMessage} />;
};

SuccessModal.displayName = 'SuccessModal';

export { SuccessModal as PopUpAlert };
export type { TMASuccessModalProps as SuccessModalProps };
export default SuccessModal;
